(function () {
  var viewedModules = {};

  function sessionValue(key) {
    try {
      return window.sessionStorage ? window.sessionStorage.getItem(key) : '';
    } catch (error) {
      return '';
    }
  }

  function setSessionValue(key, value) {
    try {
      if (window.sessionStorage && value) window.sessionStorage.setItem(key, value);
    } catch (error) {
      /* Ignore storage failures. */
    }
  }

  function queryParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (error) {
      return '';
    }
  }

  function referrerHost() {
    try {
      if (!document.referrer) return '';
      var referrer = new URL(document.referrer);
      return referrer.hostname === window.location.hostname ? '' : referrer.hostname;
    } catch (error) {
      return '';
    }
  }

  function sessionSource() {
    var value = queryParam('utm_source') || sessionValue('plume_aeo_session_source') || referrerHost() || 'direct';
    setSessionValue('plume_aeo_session_source', value);
    return value;
  }

  function sessionMedium() {
    var value = queryParam('utm_medium') || sessionValue('plume_aeo_session_medium');
    if (!value) value = referrerHost() ? 'referral' : 'none';
    setSessionValue('plume_aeo_session_medium', value);
    return value;
  }

  function sendEvent(eventName, payload) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }

    if (Array.isArray(window.dataLayer)) {
      var dataLayerPayload = { event: eventName };
      dataLayerPayload[eventName] = payload;
      window.dataLayer.push(dataLayerPayload);
    }
  }

  function modulePayload(module) {
    return {
      page_path: window.location.pathname || '',
      page_type: module.getAttribute('data-page-type') || 'aeo_article',
      module_name: module.getAttribute('data-module-name') || 'expert_source_module',
      module_position: module.getAttribute('data-module-position') || 'inline',
      session_source: sessionSource(),
      session_medium: sessionMedium()
    };
  }

  function sourceClickPayload(link) {
    return {
      page_path: window.location.pathname || '',
      source_name: link.getAttribute('data-source-name') || (link.textContent || '').trim(),
      source_type: link.getAttribute('data-source-type') || 'source',
      permission_status: link.getAttribute('data-permission-status') || 'no_permission',
      destination_url: link.getAttribute('href') || '',
      session_source: sessionSource(),
      session_medium: sessionMedium()
    };
  }

  function initModuleViews() {
    var modules = document.querySelectorAll('[data-expert-source-module="true"]');
    if (!modules.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var module = entry.target;
        var key = [
          window.location.pathname,
          module.getAttribute('data-module-name') || 'expert_source_module',
          module.getAttribute('data-module-position') || 'inline'
        ].join('|');

        if (viewedModules[key]) return;
        viewedModules[key] = true;
        sendEvent('expert_source_module_view', modulePayload(module));
        observer.unobserve(module);
      });
    }, { threshold: 0.35 });

    modules.forEach(function (module) {
      observer.observe(module);
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('[data-expert-source-click="true"]') : null;
    if (!link) return;
    sendEvent('expert_source_click', sourceClickPayload(link));
  }, false);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModuleViews);
  } else {
    initModuleViews();
  }
})();

